import { createHook, createStore } from 'react-sweet-state';
import teamCentralRestClient from '../clients/team-central-rest-client';
const initialState = {
  isTeamCentral: false,
  hasWorkspace: false,
  orgHasWorkspace: false,
  teamCentralHandlers: {}
};
const actions = {
  initTeamCentral: (appName, cloudId, teamCentralHandlers = {}) => ({
    setState
  }) => {
    const isTeamCentral = appName === 'teamcentral-directory';
    if (isTeamCentral) {
      // Assume site already has a TC workspace if directory is running in TC mode
      setState({
        isTeamCentral,
        hasWorkspace: true,
        orgHasWorkspace: true,
        teamCentralHandlers
      });
    } else {
      // Otherwise, fetch for workspace information
      const requests = [teamCentralRestClient.hasWorkspaceForCloudId(cloudId), teamCentralRestClient.doesOrgContainAnyWorkspace(cloudId)];
      Promise.all(requests).then(([hasWorkspace, orgHasWorkspace]) => {
        setState({
          isTeamCentral: false,
          hasWorkspace,
          orgHasWorkspace,
          teamCentralHandlers
        });
      });
    }
  }
};
/**
 * Manage states of searching People and Teams in search home page.
 */
const Store = createStore({
  initialState,
  actions,
  name: 'SearchHomePage'
});
export const useTeamCentralStore = createHook(Store);
export const useTeamCentralStoreApi = createHook(Store, {
  selector: null
});
export const useIsTeamCentral = createHook(Store, {
  selector: s => s.isTeamCentral
});
export const useTeamCentralPresent = createHook(Store, {
  selector: s => s.isTeamCentral || s.hasWorkspace || s.orgHasWorkspace
});